import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { selectedFeritlityData, setEditDetails, setPatientDetails } from '../../Redux/Slice/fertilitySlice';
import { deleteFertility } from '../../Redux/Thunk/fertiltyActions';

const Actions = ({data, loaderchange}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const handleEdit = async () => {
    // setPatientDetails(data);
    dispatch(setEditDetails(true));
    dispatch(selectedFeritlityData(data));
    console.log(`location.state?.from -->`, location.state?.from);
    navigate('/fertility/add', {
      state: {from: location.pathname}
    });
  };

  const handleView = () => {
    const patientDetails = {uuid: data.patient_p_uhid, patientId: data.patient, name: data.patient_name, age: data.patient_age};
    dispatch(setPatientDetails(patientDetails));
    navigate('/fertility/view');
  };

  const handleDelete = () => {
    loaderchange('true');
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then(async result => {
      if (result.isConfirmed) {
        try {
          await dispatch(deleteFertility(data.id)).unwrap();
          loaderchange('false');
          Swal.fire({
            title: 'Deleted!',
            text: 'Your entry has been deleted.',
            icon: 'success',
            showConfirmButton: false,
            timer: 1500
          });
        } catch (error) {
          console.error('Deletion failed:', error);
          loaderchange('false');
          Swal.fire('Error', 'Deletion failed', 'error');
        }
      }
    });
  };

  return (
    <div className='actions-container'>
      <button className='btn btn-danger btn-sm delete' onClick={handleEdit}>
        <i className='bi bi-pencil'></i> Edit
      </button>
      <button type='button' class='btn btn-danger btn-sm delete' onClick={handleView}>
        <i class='bi bi-eye-fill'></i> View
      </button>
      <button className='btn btn-danger btn-sm trash' onClick={handleDelete}>
        <i className='bi bi-trash'></i> Delete
      </button>
    </div>
  );
};

export default Actions;
